<template>
  <div class="History">
    <div class="page-title">{{ $t("lang.title_history") }}</div>
    <div>
      <ATable
        ref="table"
        :placeholder="placeholder"
        :search_field="search_field"
        :loading="loading"
        :data="items"
        :page-size="35"
        border
        hide-button-insert
      >
        <div slot="search">
          <div class="right-search-head inline" style="margin-left: 10px">
            <div class="inline">
              <APeriodSelector
                ref="period"
                v-model="searchPeriod"
                @change="handleChangePeriod"
              />
            </div>
            <div class="inline">
              <el-button
                type="primary"
                size="mini"
                round
                v-shortkey="['f5']"
                @shortkey.native="handleClickSearch"
                @click="handleClickSearch"
                >{{ $t("button.search") }}(F5)</el-button
              >
            </div>
          </div>
        </div>
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.indexw"
        />
        <el-table-column prop="table_name" label="정보" width="100" />
        <el-table-column prop="command" label="명령" width="100" />
        <el-table-column prop="flag" label="분류" width="60">
          <template slot-scope="scope">{{
            resolveFlag(scope.row.flag)
          }}</template>
        </el-table-column>
        <el-table-column label="건수" width="50">
          <template slot-scope="scope">{{
            resolveDataCount(scope.row.data)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="data"
          :label="$t('lang.content')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            resolveData(scope.row.data)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.altered_person')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          label="변경시간"
          :formatter="util.dateTimeFormat"
          :width="$width.datetime"
        />
      </ATable>
    </div>
  </div>
</template>

<script>
export default {
  name: "History",
  data() {
    return {
      search_field: ["table_name", "command", "created_user_name"],
      placeholder: "정보,  명령, 변경인",
      searchPeriod: "0d",
      loading: false,
      items: [],
    };
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.listHistory(this.period).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, "수주", res.message);
          return;
        }
        let items = res.data;
        items.map((item) => {
          this.addDataProperty(item);
        });
        this.items = items;
      });
    },
    addDataProperty(item) {
      item.table_name = this.$t("lang." + item.table);
    },
    resolveFlag(flag) {
      switch (flag) {
        case "C":
          return "추가";
        case "D":
          return "삭제";
        default:
          return "수정";
      }
    },
    resolveDataCount(data) {
      if (Array.isArray(data)) {
        return data.length;
      } else {
        return 1;
      }
    },
    resolveData(data) {
      if (!Array.isArray(data)) {
        delete data.created_at;
        delete data.created_user_name;
        delete data.modified_at;
        delete data.modified_user_name;
        delete data.modified_at;
        delete data.modified_user_name;
      }
      return JSON.stringify(data, null, 2);
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
  },
};
</script>

